export default {"src":"/_next/static/media/Esnova.d096eff7.svg","height":48,"width":88};